import {
  ICommentParent,
  IGeneralComments,
  ISpecificGroups,
  ISpecificGroup,
} from "../store/types/deal";
import queryString from "query-string";

export const generalCommentToRender = (
  data: IGeneralComments
): ICommentParent[] => {
  if (!data) return [];
  return Object.values(data);
};

export const sortSpecificGroups = (
  data: ISpecificGroups,
  formQuestionsUUIDs: string[]
): ISpecificGroup[] => {
  const sortByQuestions: ISpecificGroups = formQuestionsUUIDs?.reduce(
    (acc, uuid) => {
      return data[uuid] ? { ...acc, ...{ [uuid]: data[uuid] } } : acc;
    },
    {}
  );

  const sections = sortByQuestions ? Object.values(sortByQuestions) : [];

  return sections;
};

export const getParamsFromSearch = (search: string) =>
  queryString.parse(search);

export type IFilterObject = {
  [key in string | number]: any;
};

export const filterObject = (
  keys: string[] | number[],
  obj: IFilterObject
): IFilterObject => {
  if (!keys.length) {
    return obj;
  }
  const result: IFilterObject = obj;
  keys.forEach((key: string | number) => delete result[key]);
  return result;
};
